import { render, staticRenderFns } from "./etc.applyBottom.vue?vue&type=template&id=7845aa9e&scoped=true"
import script from "./etc.applyBottom.vue?vue&type=script&lang=js"
export * from "./etc.applyBottom.vue?vue&type=script&lang=js"
import style0 from "./etc.applyBottom.vue?vue&type=style&index=0&id=7845aa9e&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7845aa9e",
  null
  
)

export default component.exports